import { useBankOnboarding } from "./hooks/useBankOnboarding";
import BankOnboardingView from "./view";

export default function BankOnboardingCard({ onApproved }) {
    const props = useBankOnboarding({ onApproved });
    return <BankOnboardingView {...props} />;
}
